// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__VFP86","rotate":"style_rotate__ld0MN","prixClipFix":"style_prixClipFix__xzVlj"};